const cn = {
    "登录":"登录",
    "注册":'注册'
}
export default cn


// WEBPACK FOOTER //
// ./src/utils/lang/config/cn.js